import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("lros_lang") || "sv");

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((next) => {
    setLangState(next);
    localStorage.setItem("lros_lang", next);
  }, []);

  const t = useCallback(
    (path) => {
      const parts = path.split(".");
      let node = translations[lang];
      for (const p of parts) {
        node = node?.[p];
        if (node == null) return path;
      }
      return node;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
